import home from './home';
import userManagement from './user-management';
import bidders from './bidders';
import requests from './requests';
import tenders from './tenders';
import visits from './visits';
import masterData from './master-data';

export default [
    ...home,
    ...userManagement,
    ...bidders,
	...requests,
    ...tenders,
	...visits,
	...masterData
];
